import { AlertIcon, InformationIcon } from '@atgfr8/icons';
import { Show } from 'solid-js';
import { loadSureStore } from '@store/orders';
import { HoverPop } from '@components/HoverPop';

import {
  freightValue,
  isEqualValue,
  isLoadSureVendorAttached,
  loadId,
  loadSureCertificate,
} from './LoadSureHelpers';
export const LoadSureWarning = () => {
  return (
    <div class="flex flex-col gap-y-2">
      <Show
        when={
          (isLoadSureVendorAttached() &&
            loadSureStore.isDirty.includes(loadId())) ||
          !isEqualValue()
        }
      >
        <div class="w-full bg-[#fffde7] rounded-lg p-2 border-solid border-[#fbc02d] border-[3px]">
          <div class="flex items-center gap-x-2">
            <AlertIcon color="#fbc02d" />
            <div class="flex flex-col w-full">
              <div class="flex gap-x-2 items-center">
                <div class="font-semibold text-lg">
                  Insurance Update Required
                </div>
                <Show when={!isEqualValue()}>
                  <HoverPop
                    anchor={<InformationIcon color="#fbc02d" />}
                    render={true}
                  >
                    <div class="text-sm p-4">
                      Insurance has a cargo value of $
                      {loadSureCertificate()?.quoteCargoValue} and the load has
                      a cargo value of ${freightValue()}.
                    </div>
                  </HoverPop>
                </Show>
              </div>
              <div class="leading-tight">
                Updates to the Equipment Type, Cargo Value, First Pickup, or
                Last Drop-off of the load require a new insurance quote. Please
                requote to keep coverage valid.
              </div>
              <div class="text-sm ">
                <span class="font-semibold">Note: </span>
                If you click "Requote", you'll first be asked to cancel your
                existing policy before getting new quotes. Want to keep your
                existing policy? Just revert your changes.
              </div>
            </div>
          </div>
        </div>
      </Show>
      <Show when={Number(freightValue()) > 1000000}>
        <div class="w-full bg-[#efccd2] rounded-lg p-2 border-solid border-[#b81a36] border-[3px]">
          <div class="flex items-center gap-x-2">
            <AlertIcon color="#b81a36" />
            <div class="flex flex-col w-full">
              <div class="text-sm font-semibold">
                Cargo Value Exceeds Blanket All-Risk Policy Limit - Action
                Required
              </div>
              <div class="text-sm leading-relaxed">
                This load has a cargo value greater than $1,000,000. Armstrong's
                Blanket All-Risk Policy only covers up to $1,000,000 per load.
                You must contact the Claims Department{' ('}
                <a
                  href="mailto:claims@armstrongtransport.com"
                  class="text-armstrong-blue underline"
                >
                  claims@armstrongtransport.com
                </a>
                {') '}
                to secure additional coverage for this load. Agents are also
                responsible for verifying both the Customer and the assigned
                Carrier have adequate insurance coverage valued over $1,000,000.
              </div>
            </div>
          </div>
        </div>
      </Show>
    </div>
  );
};
